import React from "react";
import "./App.css";
// import { ChangeType } from "./components/ChangeType";
// import { RevealAnswer } from "./components/RevealAnswer";
// import { StartAttempt } from "./components/StartAttempt";
// import { TwoDice } from "./components/TwoDice";
// import { CycleHoliday } from "./components/CycleHoliday";
// import { Counter } from "./components/Counter";
// import { DoubleHalf } from "./bad-components/DoubleHalf";
// import { ColoredBox } from "./bad-components/ColoredBox";
// import { ShoveBox } from "./bad-components/ShoveBox";
// import { ChooseTeam } from "./bad-components/ChooseTeam";
// import { CheckAnswer } from "./form-components/CheckAnswer";
// import { GiveAttempts } from "./form-components/GiveAttempts";
// import { EditMode } from "./form-components/EditMode";
// import { MultipleChoiceQuestion } from "./form-components/MultipleChoiceQuestion";
// import { ChangeColor } from "./form-components/ChangeColor";

function App(): JSX.Element {
    return (
        <div className="App">
            <header className="App-header">KDR UD</header>
            <img
                src="https://www.kdr.com/wp-content/uploads/2022/04/KDR-coat-of-arms.png"
                width="500"
                height="333"
            ></img>
            {/* <hr></hr>
            <DoubleHalf></DoubleHalf>
            <hr></hr>
            <ChooseTeam></ChooseTeam>
            <hr></hr>
            <ColoredBox></ColoredBox>
            <hr></hr>
            <ShoveBox></ShoveBox>
            <hr></hr>
            <Counter></Counter>
            <hr />
            <RevealAnswer></RevealAnswer>
            <hr />
            <StartAttempt></StartAttempt>
            <hr />
            <TwoDice></TwoDice>
            <hr />
            <ChangeType></ChangeType>
            <hr />
            <CycleHoliday></CycleHoliday>
            <hr />
            <CheckAnswer expectedAnswer={"42"}></CheckAnswer>
            <hr />
            <GiveAttempts></GiveAttempts>
            <hr />
            <EditMode></EditMode>
            <hr />
            <ChangeColor></ChangeColor>
            <hr />
            <MultipleChoiceQuestion
                options={["2", "10", "3"]}
                expectedAnswer={"10"}
            ></MultipleChoiceQuestion> */}
        </div>
    );
}

export default App;
